const sharedClasses =
    "h-[50px] px-[60px] w-auto  relative inline-flex items-center justify-center whitespace-nowrap rounded-[10px] text-base font-bold leading-snug border  transition-colors active:ring-4 disabled:opacity-25 disabled:cursor-not-allowed";

export const rawButtonVariants = {
    primary: `${sharedClasses} bg-brand-secondary !text-brand-white border-brand-secondary hover:bg-brand-secondary-darken active:bg-brand-secondary-darken active:ring-brand-secondary-darken/40 hover:text-brand-white`,
    secondary: `${sharedClasses} bg-brand-quaternary !text-brand-white border-brand-quaternary hover:bg-brand-quaternary-darken active:bg-brand-quaternary-darken active:ring-brand-quaternary-darken/40 hover:text-brand-white`,
    tertiary: `${sharedClasses} bg-transparent !text-brand-white border-brand-white hover:text-brand-primary hover:bg-brand-white active:text-brand-primary active:bg-brand-white active:ring-brand-primary/40`,
    link: `${sharedClasses} bg-transparent text-brand-secondary border-transparent hover:text-brand-secondary-darken hover:underline active:ring-0 font-normal`,
};

export const buttonVariants = {
    primary: {
        solidClasses: rawButtonVariants.primary,
        outlinedClasses: rawButtonVariants.primary,
    },
    secondary: {
        solidClasses: rawButtonVariants.secondary,
        outlinedClasses: rawButtonVariants.secondary,
    },
    tertiary: {
        solidClasses: rawButtonVariants.tertiary,
        outlinedClasses: rawButtonVariants.tertiary,
    },
    link: {
        solidClasses: rawButtonVariants.link,
        outlinedClasses: rawButtonVariants.link,
    },
};
